import { render, staticRenderFns } from "./ISACI2025.vue?vue&type=template&id=1f9b6a78"
import script from "./ISACI2025.vue?vue&type=script&lang=js"
export * from "./ISACI2025.vue?vue&type=script&lang=js"
import style0 from "./ISACI2025.vue?vue&type=style&index=0&id=1f9b6a78&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports